import { ToastrService } from 'ngx-toastr';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, NgModel } from '@angular/forms';
import { Router } from '@angular/router';
import { EvaluationVehicle, FastQuote, FastQuoteBids, FastQuoteHistory, StatusEvaluation } from '@app-model/evaluation';
import { AuctionHistoryEvent, AuctionHistoryEventType } from '@app-model/vehicle';
import { FastQuoteService } from '@app-services/fast-quote.service';
import { DealerInfo, OemDealerService } from '@app-services/oem-dealer.service';
import { TargetBuyersLabel } from '@app/views/private/admin/model/advertisers';
import { SessionService } from '@app/store/session/session.service';
import { OpenService } from '@app-services/open.service';
import * as moment from 'moment';
import { UserInfo, LayoutVars } from '@app/store/session/session.store';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { DialogFastQuoteRulesComponent } from '@app-components/dialog/dialog-fast-quote-rules/dialog-fast-quote-rules.component';
import { DialogReasonCancellationComponent, DialogReasonCancellationData, DialogReasonCancellationResult } from '@app-components/dialog/dialog-reason-cancellation/dialog-reason-cancellation.component';
import { reloadCurrentRoute } from '@app-utils/router-utils';
import { Role } from '@app/store/session/session.store';
import { Permission } from '@app/store/session/session.store';
import { DialogDirectSaleComponent } from '@app-components/cards/auction-management/dialog-direct-sale/dialog-direct-sale.component';
import { DialogPotentialDealersComponent } from '@app-components/dialog/dialog-potential-dealers/dialog-potential-dealers.component';

@Component({
  selector: 'app-fast-quote',
  templateUrl: './fast-quote.component.html',
  styleUrls: ['./fast-quote.component.scss']
})
export class FastQuoteComponent implements OnInit {
  loading: boolean;
  showFastQuoteDetail = false;
  allEvents: AuctionHistoryEvent[];
  events: AuctionHistoryEvent[];
  currentBid: AuctionHistoryEvent;
  StatusEvaluation: StatusEvaluation;
  currentBidderInfo: DealerInfo;
  longFastQuote: boolean;
  historyItems: FastQuoteHistory[];
  allTargets = TargetBuyersLabel.allTargets;
  selectedTarget: string;
  exclusiveGroups = [];
  selectedGroups = [];
  exclusiveGroupInput: any;
  includeExclusiveGroups = false;
  isAuction: boolean = false;

  accordionActive: boolean;

  @Input() vehicle: EvaluationVehicle;
  @Input() userInfo: UserInfo;
  @Input() theme: string;
  @Output() openInvoicePaidModalEmitter = new EventEmitter<number>();
  @Input() comissionPaid: boolean;

  minPriceControl: FormControl = new FormControl(null, []);
  bidStepControl: FormControl = new FormControl(null, []);
  personalizedFinishTime: FormControl = new FormControl(null, []);
  expiredFastQuote: boolean;
  layoutVars: LayoutVars | null = null;

  hasPaymentLink: boolean = false;
  isSuperbidLink: boolean = false;
  loadingCancel: boolean = false;

  proposalTypeInfo = `Padrão: os compradores podem enviar propostas com qualquer valor.
  Competitiva: cada nova proposta deve ser superior à anterior.`;  

  constructor(
    private service: FastQuoteService,
    private router: Router,
    private oemDealerService: OemDealerService,
    private toastr: ToastrService,
    private sessionService: SessionService,
    private openService: OpenService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.loading = false;
    if (this.vehicle.inFastQuote) {
      this.showFastQuoteDetail = true;
    }

    this.service.isLongFastQuote(this.vehicle.id, this.theme !== 'light')
      .subscribe(resp => this.longFastQuote = resp.longFastQuote);

    if (this.vehicle.fastQuote) {
      this.vehicle.expirationTimeLeft = new Date(this.vehicle.fastQuote.expiration).getTime() - new Date().getTime();
      this.expiredFastQuote = this.vehicle.expirationTimeLeft < 0;
      this.selectedTarget = this.vehicle.fastQuote.target;
      this.isAuction = this.vehicle.fastQuote.isAuction || this.vehicle.defaultCompetitiveFastQuote;
      this.bidStepControl.setValue(this.vehicle.fastQuote.bidStep);
    } else if (this.vehicle.defaultCompetitiveFastQuote) {
      this.isAuction = true;
    }
    if (!this.selectedTarget) {

      this.sessionService.getUser().subscribe(user => {
        this.selectedTarget = this.vehicle.target ? this.vehicle.target : user.target;

        if (!this.selectedTarget) {
          this.selectedTarget = 'ALL';
        }
      });
    }


    this.initEvents();

    if (this.vehicle.fastQuote && this.vehicle.fastQuote.history) {
      this.historyItems = this.vehicle.fastQuote.history.slice(0, Math.min(3, this.vehicle.fastQuote.history.length));
    }

    const savedMin = this.vehicle.fastQuote?.minBidValue ?? this.vehicle.minSellPrice;
    if (savedMin > 0) {
      this.minPriceControl.setValue(savedMin);
    }
    this.openService.getLayoutVars().subscribe(layoutVars => this.layoutVars = layoutVars);
    this.loadGroups();
    this.updatePaymentFlags();
  }

  selectExcGroup() {
    if (this.selectedGroups.find(e => e.id == this.exclusiveGroupInput.id)) {
      return;
    }
    if (this.exclusiveGroupInput != undefined) {
      this.selectedGroups.push(this.exclusiveGroupInput);
      this.exclusiveGroupInput = '';
    }
  }

  removeSelected(index) {
    this.selectedGroups.splice(index, 1);
  }

  canReactive(): boolean {
    return !!this.vehicle.inFastQuote && this.expiredFastQuote && this.vehicle.status !== StatusEvaluation.BOUGHT;
  }

  canPublish(): boolean {
    return (this.vehicle.status == StatusEvaluation.PRICING || this.vehicle.status == StatusEvaluation.NEGOTIATION) && !this.vehicle.inFastQuote;
  }

  private initEvents(): void {
    if (this.vehicle.historyEvents) {
      if (this.vehicle.hasBids) {
        this.currentBid = this.vehicle.historyEvents.find(
          (e) => e.type === 'BID' || e.type === 'FINISHED_BID'
        );
      } else {
        this.currentBid = undefined;
      }
      this.allEvents = this.vehicle.historyEvents.filter(
        (e) => e !== this.currentBid
      );
      if (this.allEvents.length > 3) {
        this.events = this.allEvents.slice(0, 3);
      } else {
        this.events = this.allEvents;
      }


      if (this.currentBid) {
        this.oemDealerService
          .getDealerInfo(this.currentBid.dealerId)
          .subscribe((response) => (this.currentBidderInfo = response));
      }
    }
  }

  loadGroups() {
    this.oemDealerService.listExclusiveGroups(this.vehicle.oemDealerId).subscribe(response => {
      this.exclusiveGroups = response;
      if (this.showFastQuoteDetail && this.vehicle.fastQuote && this.vehicle.fastQuote.dealersExclusiveGroups && this.vehicle.fastQuote.dealersExclusiveGroups.length > 0) {
        this.vehicle.fastQuote.dealersExclusiveGroups.forEach(e => {
          this.selectedGroups.push(this.exclusiveGroups.filter(g => g.id === e)[0]);
        });
      }
    })
  }

  get blockSellerSeeOffers(): boolean {
    return this.userInfo && this.userInfo.blockSellerSeeOffers;
  }

  canViewFastQuoteProposals(): boolean {
    return this.userInfo?.hasAnyPermissionOrLegacy(
      Permission.VIEW_ALL_FAST_QUOTE_PROPOSALS,
      Permission.VIEW_HIGHEST_FAST_QUOTE_PROPOSAL,
    ) ?? false;
  }

  trackFastQuoteBid(index: number, bid: FastQuoteBids): string {
    return `${bid.dealerId}-${bid.value}-${bid.status}-${index}`;
  }

  private validateFinishTime(): boolean {
    if (!this.personalizedFinishTime.value) {
      return true;
    }

    const timeArr: string[] = this.personalizedFinishTime.value.split(":");
    if (timeArr.length === 2) {
      const hours = parseInt(timeArr[0]);
      const minutes = parseInt(timeArr[1]);

      if (!isNaN(hours) && !isNaN(minutes)
        && hours <= 23 && hours >= 0
        && minutes <= 59 && minutes >= 0) {
        return true;
      }
    }

    this.toastr.error(
      "Problemas com o formato do horário de finalização da cotação rápida. Use o formato hh:mm, por exemplo 17:30.",
      null,
      {
        progressBar: true,
      }
    );
    return false;
  }

  public sendFastQuote() {
    this.loading = true;
    if (!this.validateFinishTime() || this.bidStepControl.invalid) {
      this.loading = false;
      return;
    }

    let groups = [];
      if (this.selectedGroups.length > 0 && (this.includeExclusiveGroups || this.selectedTarget === 'EXCLUSIVE_GROUPS')) {
        this.selectedGroups.forEach(e => {
          groups.push(e.id);
        });
      }

      let isAuction = false;
      let bidStep;

      if(this.isAuction) {
        isAuction = true;
        bidStep = this.bidStepControl.value;
      }

    let observable;
    if (this.theme == 'light') {
      observable = this.service.sendTradeFastQuote(this.vehicle.id, this.minPriceControl.value, this.personalizedFinishTime.value, this.selectedTarget, groups, isAuction, bidStep);
    } else {
      observable = this.service.sendEvalFastQuote(this.vehicle.id, this.minPriceControl.value, this.personalizedFinishTime.value, this.selectedTarget, groups, isAuction, bidStep);
    }

    observable.subscribe((response: any) => {
      reloadCurrentRoute(this.router);
    }, error => {
      this.loading = false;
    });
  }

  public isFastQuote() {
    return !!this.vehicle.inFastQuote && !!this.vehicle.fastQuoteId && this.vehicle.status !== StatusEvaluation.BOUGHT;
  }
  public soldFastQuote() {
    return (this.vehicle.status === StatusEvaluation.SOLD_FAST_QUOTE) || this.vehicle.status === StatusEvaluation.BOUGHT;
  }
  public fastQuoteActive() {
    const date = new Date();
    if (this.vehicle.fastQuote.expiration > date) {
      return true;
    }
    return false;
  }

  openCancelFastQuoteConfirmation() {
    this.openFastQuoteRulesDialog('cancel');
  }

  private reload(): void {
    reloadCurrentRoute(this.router);
  }

  public fastQuoteHasBids() {
    return (this.vehicle.fastQuote && this.vehicle.fastQuote.bidSuggestions && this.vehicle.fastQuote.bidSuggestions.length > 0);
  }

  onValChange(act) {
    if (act) {

      if (!this.validateFinishTime() || this.bidStepControl.invalid) {
        this.loading = false;
        return;
      }
      let groups = [];
      if (this.selectedGroups.length > 0) {
        this.selectedGroups.forEach(e => {
          groups.push(e.id);
        });
      }

      let isAuction = false;
      let bidStep;
      if(this.isAuction) {
        isAuction = true;
        bidStep = this.bidStepControl.value;
      }

      this.service.sendTradeFastQuote(this.vehicle.id, this.minPriceControl.value, this.personalizedFinishTime.value, this.selectedTarget, groups, isAuction, bidStep).subscribe((response: any) => {
        if (response.success && response.status === 'OK') {
          reloadCurrentRoute(this.router);
        }
      });
    }
  }

  getEventTypeLabel(type: string): string {
    return AuctionHistoryEventType[type];
  }
  showDealerName(event: AuctionHistoryEvent): boolean {
    return (
      event.dealerName &&
      (event.type === 'BID' ||
        event.type === 'FINISHED_BID' ||
        event.type === 'BID_SUGGESTION_RECEIVED' ||
        event.type === 'BID_SUGGESTION_IGNORED' ||
        event.type === 'BID_SUGGESTION_ACCEPTED')
    );
  }
  showUserName(event: AuctionHistoryEvent): boolean {
    return (
      event.type === 'AUCTION_CREATED' ||
      event.type === 'MIN_BID_CHANGE' ||
      event.type === 'MAX_BID_CHANGE' ||
      event.type === 'INACTIVATED' ||
      event.type === 'CANCELLED' ||
      event.type === 'BID_SUGGESTION_IGNORED' ||
      event.type === 'BID_SUGGESTION_ACCEPTED' ||
      event.type === 'DELETED'
    );
  }

  get additionalEvents(): number {
    return this.allEvents
      ? this.allEvents.length - (this.events ? this.events.length : 0)
      : 0;
  }

  enableAllEvents(): void {
    this.events = this.allEvents;
  }

  openModal(): void {
    this.openFastQuoteRulesDialog('rules');
  }

  private openFastQuoteRulesDialog(mode: 'rules' | 'cancel'): void {
    this.dialog.open(DialogFastQuoteRulesComponent, {
      width: '500px',
      maxWidth: '95vw',
      panelClass: 'dialog-fast-quote-rules-panel',
      data: {
        mode,
        expirationTimeLeft: this.vehicle.expirationTimeLeft ?? 0,
        fastQuoteId: mode === 'cancel' ? this.vehicle.fastQuoteId : undefined,
      },
    });
  }

  enableAllHistoryItems(): void {
    this.historyItems = this.vehicle.fastQuote.history;
  }

  getEventText(item: FastQuoteHistory): string {
    let title = '';
    switch (item.type) {
      case 'ACTIVATED':
        title = 'Ativada';
        break;
      case 'ACCEPTED_BID':
        title = 'Oferta aceita';
        break;
      case 'NEW_BID':
        title = 'Nova oferta';
        break;
      case 'REJECTED_BID':
        title = 'Oferta rejeitada';
        break;
      case 'CHANGED_MIN_BID':
        title = 'Oferta mínima atualizada';
        break;
      case 'BID_REMOVED':
        title = 'Oferta cancelada';
        break;
      case 'CANCELLED':
        title = 'Cotação rápida cancelada';
        break;
      case 'EXPIRED':
        title = 'Expirada automaticamente';
        break;
      case 'COUNTER_OFFER_CREATED':
        title = 'Contra proposta criada';
        break;
      case 'COUNTER_OFFER_REJECTED':
        title = 'Contra proposta rejeitada';
        break;
      case 'COUNTER_OFFER_ACCEPTED':
        title = 'Contra proposta aceita';
        break;
      case 'DELETED':
        title = 'Cotação rápida removida';
        break;
      case 'SOLD_CANCELLED':
        title = 'Venda cancelada';
        break;
    }

    let result = title;

    if (item.userName && item.type !== 'BID_REMOVED' && item.type !== 'NEW_BID') {
      result += ' por ' + item.userName;
    }
    return result;
  }

  get additionalHistoryItems(): number {
    if (this.historyItems) {
      return this.vehicle.fastQuote.history.length - this.historyItems.length;
    }
  }

  getTargetLabel(target: string): string {
    return TargetBuyersLabel.getLabel(target);
  }

  showStats(): boolean {
    return this.vehicle.fastQuote !== undefined && this.vehicle.fastQuote.stats !== undefined
      && moment(this.vehicle.fastQuote.expiration) > moment(new Date())
  }

  openInvoicePaidModal(): void {
    this.openInvoicePaidModalEmitter.emit();
  }

  isCommissionPaid(): boolean {
    return !!this.vehicle?.fastQuote?.commissionPaidAt;
  }

  hasCommissionValue(): boolean {
    return this.vehicle?.fastQuote?.commissionValueCents != null;
  }

  getCommissionValue(): number {
    return (this.vehicle?.fastQuote?.commissionValueCents ?? 0) / 100;
  }

  private updatePaymentFlags(): void {
    const url = this.vehicle?.bankSlipUrl || '';
    this.hasPaymentLink = !!url;
    this.isSuperbidLink = url.includes(environment.superBidAuthorizationUrl + '/payment/');
  }

  openPayment(): void {
    if (!this.hasPaymentLink) {
      return;
    }
    if (this.isSuperbidLink) {
        this.copySuperbidAuthUrl();
        return;
    }
    window.open(this.vehicle.bankSlipUrl);
  }

  copySuperbidAuthUrl(): void {
    navigator.clipboard.writeText(this.vehicle.bankSlipUrl);
    this.toastr.success('Link copiado para a área de transferência.');
  }

  hasPermissionCancelSale(): boolean {
    if (!this.userInfo) {
      return false;
    }

    const hasRoles = this.userInfo.hasPermissionDeskSell();
    const hasPermission = this.userInfo.hasPermission(Permission.CANCEL_SALE);

    return hasRoles || hasPermission;
  }

  canCancelSell(): boolean {
    return !!this.userInfo && this.hasPermissionCancelSale();
  }

  isWithinCancelSalePeriod(): boolean {
    if (!this.vehicle?.fastQuote?.soldAt) {
      return false;
    }

    const minSoldDate = moment().subtract(30, 'days').toDate();
    return new Date(this.vehicle.fastQuote.soldAt).getTime() >= minSoldDate.getTime();
  }

  canShowCancelBySaleDate(): boolean {
    if (this.userInfo?.isAdmin()) {
      return true;
    }

    return this.isWithinCancelSalePeriod();
  }

  canShowCancelAuctionButton(): boolean {
    return this.hasPaymentLink
      && !!this.vehicle?.fastQuoteId
      && (this.vehicle?.status === StatusEvaluation.SOLD_FAST_QUOTE || this.vehicle?.status === StatusEvaluation.SOLD)
      && this.canCancelSell()
      && this.canShowCancelBySaleDate();
  }

  private getCancelAuctionDialogData(): DialogReasonCancellationData {
    return {
      vehicle: {
        ...(this.vehicle as any),
        sold: true,
      },
      currentBidderInfo: this.currentBidderInfo,
      isAdmin: !!this.userInfo?.isAdmin(),
      canCancelSell: this.canCancelSell(),
      title: 'Deseja cancelar a venda?',
    } satisfies DialogReasonCancellationData;
  }

  openCancelAuctionModal(): void {
    if (!this.canShowCancelAuctionButton() || this.loadingCancel) {
      return;
    }

    const dialogRef = this.dialog.open(DialogReasonCancellationComponent, {
      width: '520px',
      disableClose: true,
      hasBackdrop: true,
      panelClass: 'dialog-cancel-auction',
      data: this.getCancelAuctionDialogData(),
    });

    dialogRef.afterClosed().subscribe((result: DialogReasonCancellationResult | null) => {
      if (result) {
        this.cancelAuction(result.cancellationReason, result.cancellationNote);
      }
    });
  }

  cancelAuction(cancellationReason: string, cancellationNote?: string): void {
    if (!this.vehicle?.fastQuoteId || this.loadingCancel) {
      return;
    }

    this.loadingCancel = true;
    this.service.cancelSoldFastQuote(this.vehicle.fastQuoteId, {
      cancellationReason,
      ...(cancellationNote ? { cancellationNote } : {}),
    }).subscribe({
      next: () => {
        this.toastr.success('Venda cancelada com sucesso.');
        setTimeout(() => this.reload(), 1500);
      },
      error: (err) => {
        this.loadingCancel = false;
        const message = err?.error?.message ?? err?.error?.error ?? 'Não foi possível cancelar. Verifique o motivo informado.';
        this.toastr.error(message);
      },
    });
  }

  hasPermissionDirectSale(): boolean {
    if (!this.userInfo) {
      return false;
    }
    const scopeMatch = this.theme
      ? this.userInfo.locationsIds?.includes((this.vehicle as any)?.locationId)
      : this.userInfo.evalDealersIds?.includes(this.vehicle?.evalDealerId);

    const hasRoles = this.userInfo.hasRoles(Role.ADMIN, Role.OEM_DEALER_MANAGER);
    const hasPermission = this.userInfo.hasPermission(Permission.DIRECT_SALE_VEHICLE);

    return !!(hasRoles || (hasPermission && scopeMatch));
  }

  canShowDirectSale(): boolean {
    if (!this.vehicle) {
      return false;
    }
    return this.hasPermissionDirectSale() &&
      this.vehicle.allowDirectSale &&
      (this.theme === 'light'
        ? this.vehicle.status !== 'SOLD'
        : !this.soldFastQuote() && (this.canPublish() || this.canReactive() || this.vehicle.inFastQuote));
  }

  openDirectSaleDialog(): void {
    const dialogRef = this.dialog.open(DialogDirectSaleComponent, {
      width: '660px',
      maxWidth: '95vw',
      hasBackdrop: true,
      panelClass: 'dialog-direct-sale-panel',
      data: {
        vehicleId: this.vehicle?.id,
        oemDealerId: this.vehicle?.oemDealerId,
        costPrice: this.vehicle?.price ?? null,
        fastQuoteSource: this.theme === 'light' ? 'tradeIn' : 'evaluation',
        canAcceptBelowMinimumMargin: this.userInfo?.canAcceptProposalBelowMargin() ?? false,
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        return;
      }

      setTimeout(() => window.location.reload(), 2000);
    });
  }

  openPotentialDealersDialog(): void {
    this.dialog.open(DialogPotentialDealersComponent, {
      panelClass: "dialog-potential-dealers",
      hasBackdrop: true,
      data: {
        vehicle: this.vehicle,
        fastQuoteId: this.vehicle.fastQuoteId,
      },
      width: '1120px',
      minHeight: '90vh'
    });
  }

  canViewPotentialBuyers(): boolean {
    if (!this.userInfo) {
      return false;
    }

    return this.userInfo.hasRoles(Role.ADMIN, Role.OEM_DEALER_MANAGER) || 
    this.userInfo.hasPermission(Permission.VIEW_POTENTIAL_BUYERS);
  }
}